import React from 'react';
import { AppButton, Box, Inscription, Preloader, RoundCloseIcon } from '@common-fe/common-fe';

import { ModalWrapper } from '@/components/wrappers';
import theme from '@/styles/theme';

import usePayoutDefinitionDeleteModal from './hooks/usePayoutDefinitionDeleteModal';

const DEFAULT_TITLE = 'Delete Payout Definition';
const ERROR_TITLE = "This payout definition is linked to active processing rules and can't be deleted";

interface Props {
  payoutDefinitionId: string;
}

export const PayoutDefinitionDeleteModal: React.FC<Props> = ({ payoutDefinitionId }) => {
  const { modalVisible, hasLinkedError, isLoading, handleClose, handleDelete } =
    usePayoutDefinitionDeleteModal({ payoutDefinitionId });

  return (
    <ModalWrapper testId="PayoutDefinitionDeleteModal" visible={modalVisible} onSetVisible={handleClose}>
      <Box margin={{ bottom: 'spacing24', top: 'spacing24' }} align="center">
        <RoundCloseIcon size="48px" color={theme.colors.danger} />
        <Box margin={{ top: 'spacing12' }}>
          <Inscription size="24px" weight={700} lineHeight="32px" textAlign="center">
            {hasLinkedError ? ERROR_TITLE : DEFAULT_TITLE}
          </Inscription>
        </Box>
      </Box>

      <Box direction="row" fill="horizontal" margin={{ bottom: 'spacing24' }} justify="center" width="medium">
        {hasLinkedError ? (
          <Box width="150px">
            <AppButton
              testId="PayoutDefinitionDeleteModal_got-it"
              width="100%"
              type="button"
              onClick={handleClose}
            >
              Got It!
            </AppButton>
          </Box>
        ) : (
          <>
            <Box width="150px">
              <AppButton
                testId="PayoutDefinitionDeleteModal_cancel"
                buttonType="secondary"
                width="100%"
                type="button"
                onClick={handleClose}
              >
                Cancel
              </AppButton>
            </Box>
            <Box width="170px" margin={{ left: 'spacing12' }}>
              <AppButton
                testId="PayoutDefinitionDeleteModal_delete"
                color="red"
                width="100%"
                type="button"
                onClick={handleDelete}
                disabled={isLoading}
              >
                {isLoading ? <Preloader /> : 'Yes, Delete'}
              </AppButton>
            </Box>
          </>
        )}
      </Box>
    </ModalWrapper>
  );
};
